// views/Dashboard/PainelExecutivo/components/ComparativoResumo.tsx
import React from 'react';

export interface ItemComparativo {
  titulo: string;
  valorAtual: number;
  valorComparacao: number;
  formatar: (v: number) => string;
  /** Subir é ruim (ex.: reprovados): a seta continua pelo sinal, a cor se inverte. */
  inverso?: boolean;
}

interface Props {
  itens: ItemComparativo[];
  rotuloComparacao: string;
}

// Bloco genérico de comparativo — cada seção monta sua própria lista de
// métricas (o que comparar e como formatar) e entrega aqui; este componente
// não sabe nada de Financeiro/Marketing/Comercial/Geradoras, só sabe
// desenhar "atual vs. comparação" com a variação percentual.
const ComparativoResumo: React.FC<Props> = ({ itens, rotuloComparacao }) => {
  if (itens.length === 0) return null;
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm p-4">
      <h3 className="text-xs font-bold text-gray-700 dark:text-gray-200 mb-3">Comparativo vs. {rotuloComparacao}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {itens.map((item) => {
          const pct = item.valorComparacao !== 0 ? ((item.valorAtual - item.valorComparacao) / item.valorComparacao) * 100 : null;
          return (
            <div key={item.titulo} className="text-xs">
              <p className="text-gray-500 dark:text-gray-400 truncate">{item.titulo}</p>
              <p className="font-bold text-gray-900 dark:text-white">{item.formatar(item.valorAtual)}</p>
              <p className="text-gray-400">{item.formatar(item.valorComparacao)} no período B</p>
              {pct !== null && (
                <p className={`font-bold ${(item.inverso ? pct <= 0 : pct >= 0) ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>
                  {pct >= 0 ? '▲' : '▼'} {Math.abs(pct).toFixed(1)}%
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComparativoResumo;
